var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveschedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.145,
    height: 20,
    viewBox: "0 0 30.145 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "event",
    transform: "translate(-6.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257",
    transform: "translate(6.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12328",
    "data-name": "Path 12328",
    d: "M32.415,14.175h0V6.357a3.4,3.4,0,0,0-3.38-3.393h-.421v-.53a2.4,2.4,0,1,0-4.8,0v.53h-8.8v-.53a2.434,2.434,0,0,0-4.868,0v.53H9.779a3.394,3.394,0,0,0-3.37,3.393V24.31A3.4,3.4,0,0,0,9.779,27.7H20.355a9.162,9.162,0,1,0,12.06-13.528ZM25.147,2.434a1.052,1.052,0,0,1,1.033-1.07h.028a1.062,1.062,0,0,1,1.073,1.05q0,.01,0,.02v2.6H25.147Zm-13.67,0a1.082,1.082,0,0,1,1.093-1.07h0a1.088,1.088,0,0,1,1.1,1.07v2.6h-2.2ZM7.743,6.357A2.059,2.059,0,0,1,9.779,4.3h.364V5.726a.652.652,0,0,0,.676.639h3.509a.658.658,0,0,0,.683-.639V4.3h8.8V5.726a.621.621,0,0,0,.6.639h3.546a.631.631,0,0,0,.652-.61c0-.01,0-.019,0-.029V4.3h.421a2.067,2.067,0,0,1,2.046,2.059V8.5H7.743V6.357ZM9.779,26.37a2.059,2.059,0,0,1-2.037-2.06V9.832H31.082V13.45a9.17,9.17,0,0,0-11.65,12.92Zm17.615,3.285a7.821,7.821,0,1,1,7.821-7.821h0A7.83,7.83,0,0,1,27.394,29.654Z",
    transform: "translate(-6.409)",
    fill: "#464646"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(26.281 17.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12329",
    "data-name": "Path 12329",
    d: "M308.664,261.957h-2.921v-4.012a.667.667,0,1,0-1.334,0v4.678a.678.678,0,0,0,.679.668h3.576a.667.667,0,1,0,0-1.334Z",
    transform: "translate(-304.409 -257.278)",
    fill: "#464646"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveschedule);
export default __webpack_public_path__ + "static/media/inactiveschedule.0f29f8a98392fe2ebb41eb726247e428.svg";
export { ForwardRef as ReactComponent };